<template>
  <div>
    <h3 class="text-secondary">Richiedi un Consulto</h3>
    <div>
      <b-toast
        variant="danger"
        id="no-ricevimento"
        title="Attenzione!"
        static
        no-auto-hide
        no-close-button
        class="text-center mx-auto"
        body-class="text-gray-dark"
      >
        <p class="text-justify mx-auto mb-0">
          {{ consulto.professionista_nome }} non è al momento disponibile per il
          teleconsulto.
        </p>

        <b-button variant="outline-danger" size="sm" @click="$router.go()"
          >Ho capito</b-button
        >
      </b-toast>
      <b-tabs
        v-if="!stop"
        align="center"
        active-nav-item-class="font-weight-bold text-secondary border-0"
        active-tab-class="font-weight-bold text-dark"
        content-class="mt-3"
        nav-class="border-0 text-white"
        no-key-nav
        v-model="tabIndex"
      >
        <b-tab title active title-item-class="disabledTab">
          <step-uno v-on:add-professionista="addProfessionista($event)" />
        </b-tab>
        <b-tab title title-item-class="disabledTab" lazy>
          <step-due
            v-on:add-disturbo="addDisturbo($event)"
            :tipo="consulto.professionista_tipo"
          />
        </b-tab>
        <b-tab title lazy title-item-class="disabledTab">
          <step-tre
            v-on:add-date="addDate($event)"
            :disponibili="orari_prof"
            :professionista="dati_prof"
          />
        </b-tab>
        <b-tab title lazy title-item-class="disabledTab">
          <step-quattro v-on:remove-index="indietro" :prenotazione="consulto" />
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>
<script>
import StepUno from "@/components/prenotazione/StepUno";
import StepDue from "@/components/prenotazione/StepDue";
import StepTre from "@/components/prenotazione/StepTre";
import StepQuattro from "@/components/prenotazione/StepQuattro";

export default {
  name: "PrenotazioneConsulto",
  components: {
    StepUno,
    StepDue,
    StepTre,
    StepQuattro,
  },
  data() {
    return {
      tabIndex: 0,
      consulto: {
        professionista_nome: null,
        professionista_tipo: null,
        professionista_rif: null,
        consulto_rif: null,
        questionario: null,
        data_inizio: null,
        data_fine: null,
        settimana: null,
        questionario_rif: null,
        questionario_nome: null,
      },
      orari_prof: ["lunedì", "martedì", "mercoledì", "giovedì", "venerdì"],
      dati_prof: null,
      stop: false,
    };
  },
  methods: {
    addProfessionista(prof) {
      // console.log(prof);
      this.consulto.professionista_tipo = prof.tipo;
      this.consulto.professionista_rif = prof.rif;
      this.consulto.professionista_nome = prof.nome;
      this.dati_prof = prof;
      this.tabIndex++;
      this.fetchOrari();
    },
    addDisturbo(disturbo) {
      // console.log(disturbo);
      this.consulto.questionario = disturbo.domande;
      this.consulto.questionario_nome = disturbo.nome;
      this.consulto.questionario_id = disturbo.questionario_id;
      this.tabIndex++;
      this.saveQuestionario();
    },
    addDate(data) {
      // console.log(data);
      this.consulto.data_inizio = data.data_inizio;
      this.consulto.data_fine = data.data_fine;
      this.consulto.settimana = data.settimana;
      this.tabIndex++;
    },
    indietro() {
      this.tabIndex--;
    },
    saveQuestionario() {
      var url = process.env.VUE_APP_VERSION + "paziente/questionario";
      var data = {
        questionario: this.consulto.questionario,
        questionario_id: this.consulto.questionario_id,
      };
      this.$axios
        .post(url, data)
        .then((res) => {
          this.consulto.questionario_rif = res.data.data.hashid;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    fetchOrari() {
      var url =
        process.env.VUE_APP_VERSION +
        "ricevimento/" +
        this.consulto.professionista_tipo +
        "/" +
        this.consulto.professionista_rif;
      this.$axios
        .get(url)
        .then((res) => {
          if (res.data.data.length > 0) {
            res.data.data.map((giorno) => {
              var correctIndex = this.orari_prof.indexOf(giorno.giorno);
              this.orari_prof.splice(correctIndex, 1, giorno);
              // console.log("**", this.orari_prof);
            });
          } else {
            this.$bvToast.show("no-ricevimento");
            this.stop = true;
          }
        })
        .catch((err) => {
          if (err.response.status === 401) {
            this.$router.go();
          }
        });
    },
  },
};
</script>
<style>
.disabledTab {
  pointer-events: none;
  display: none;
}
</style>
